module.exports = __webpack_public_path__ + "static/img/robot_error.ca48a683.svg";